module.exports = __webpack_public_path__ + "static/media/woods_gonzalez.c73cfc4e.gif";